// Minimal JS i18n used by TipTap bits

import { ref, computed, watchEffect } from 'vue'
import en from './en.js'

// If you add more languages later, import them and add here:
const MESSAGES = {
  en,
}

const DEFAULT_LANG = 'en'

// Simple event bus (no external mitt)
const listeners = new Set()
function emitLang(lang) { listeners.forEach(fn => fn(lang)) }
function onLang(fn) { listeners.add(fn); return () => listeners.delete(fn) }

// Locale state
const state = {
  lang: DEFAULT_LANG,
  fallbackLang: DEFAULT_LANG,
  messages: MESSAGES,
}

function load(lang) {
  return state.messages[lang] || {}
}

export const locale = {
  get lang() { return state.lang },
  set lang(val) {
    state.lang = state.messages[val] ? val : state.fallbackLang
    emitLang(state.lang)
  },
  get fallbackLang() { return state.fallbackLang },
  set fallbackLang(val) {
    if (state.messages[val]) state.fallbackLang = val
  },
  setMessage(lang, msg) { state.messages[lang] = msg },
  setLang(lang) { locale.lang = lang },
  setFallbackLang(lang) { locale.fallbackLang = lang },
  registerWatchLang(cb) { const off = onLang(cb); return { unsubscribe: off } },
  buildI18nHandler(lang) {
    const primary = load(lang || state.lang)
    const fallback = load(state.fallbackLang)
    return (key) => primary[key] ?? fallback[key] ?? key
  },
}

// Vue composable used in your components
export function useLocale() {
  const lang = ref(locale.lang)
  const t = computed(() => locale.buildI18nHandler(lang.value))

  watchEffect((onCleanup) => {
    const sub = locale.registerWatchLang((val) => { lang.value = val })
    onCleanup(() => sub.unsubscribe())
  })

  return { lang, t }
}